import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-2adee7d8"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "wrapper-container"
};
var _hoisted_2 = {
  class: "info-container"
};
var _hoisted_3 = {
  class: "user-name"
};
var _hoisted_4 = {
  class: "user-info"
};
var _hoisted_5 = {
  key: 2,
  class: "user-grade"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_a_divider = _resolveComponent("a-divider");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "avatar-container",
    style: _normalizeStyle("background-image: url(".concat(_ctx.avatar, ")"))
  }, null, 4), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.name), 1), _createElementVNode("div", _hoisted_4, [_ctx.sexText ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    class: "user-sex",
    style: _normalizeStyle("background-image: url(".concat(_ctx.sexPng, ")"))
  }, _toDisplayString(_ctx.sexText), 5)) : _createCommentVNode("", true), _ctx.grade ? (_openBlock(), _createBlock(_component_a_divider, {
    key: 1,
    type: "vertical",
    style: {
      "background-color": "#efefef"
    }
  })) : _createCommentVNode("", true), _ctx.grade ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.value2label(+_ctx.grade, _ctx.GRADE, _ctx.grade)), 1)) : _createCommentVNode("", true)])])]);
}